<template>
  <div class="dictionary-base">
    <data-table ref="dataTable" :option="option">
      <template slot="warehouse">
        <a-button type="primary" @click="addGoods" :disabled="isDisabled"
          >添加</a-button
        >
        <span style="margin-left:10px">{{ WarehouseGoodsName }}</span>
        <a-button type="link" v-if="WarehouseGoodsName" @click="deGoods"
          ><a-icon type="close"
        /></a-button>
      </template>
    </data-table>
    <a-modal
      centered
      title="添加物品"
      v-model="visible"
      @ok="submitGoods"
      @cancel="onCancel"
      :maskClosable="false"
      width="50%"
    >
      <data-table class="table-custom" ref="goodsTable" :option="goodsOption" />
    </a-modal>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
export default {
  components: {
    DataTable
  },
  props: {
    data: {
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      option: {},
      apiOptions: {},
      extendData: "",
      AccountTypeAttributeArray: [],
      constSelectArray: {
        AccountTypeAttribute: [
          { Text: "普通账项", Value: 0, IsSelected: false },
          { Text: "房务中心", Value: 1, IsSelected: false }
        ],
        AccountItemStatus: [
          { Text: "启用", Value: 1, IsSelected: false },
          { Text: "可删除", Value: 2, IsSelected: false },
          { Text: "禁用", Value: 0, IsSelected: false }
        ],
        AccountItemType: [
          { Text: "付款项", Value: "C", IsSelected: false },
          { Text: "消费项", Value: "D", IsSelected: false }
        ],
        AccountItemAttributes: [
          { label: "能否转应收", value: 2 },
          { label: "默认显示", value: 4 },
          { label: "押金账项", value: 32 },
          { label: "现金支付", value: 128 },
          { label: "不可输入项", value: 256 },
          { label: "支付宝支付", value: 512 },
          { label: "微信支付", value: 1024 },
          { label: "退款项", value: 2048 },
          { label: "会员卡刷卡消费", value: 4096 },
          { label: "会员卡充值", value: 8192 }
        ],
        AccountItemAttributesArray: [
          {
            Code: "C",
            Select: [
              { label: "能否转应收", value: 2 },
              { label: "默认显示", value: 4 },
              { label: "押金账项", value: 32 },
              { label: "现金支付", value: 128 },
              { label: "不可输入项", value: 256 },
              { label: "支付宝支付", value: 512 },
              { label: "微信支付", value: 1024 },
              { label: "退款项", value: 2048 },
              { label: "会员卡刷卡消费", value: 4096 },
              { label: "会员卡充值", value: 8192 }
            ]
          },
          {
            Code: "D",
            Select: [
              { label: "按数量拆账", value: 1 },
              { label: "默认显示", value: 4 },
              { label: "全日租账项", value: 8 },
              { label: "半日租账项", value: 16 },
              { label: "餐厅转客房", value: 64 },
              { label: "不可输入项", value: 256 },
              { label: "不可修改单价", value: 16384 }
            ]
          }
        ],
        AccountItemSource: [
          { Text: "可冲账", Value: 1 },
          { Text: "不可冲账", Value: 0 }
        ],
        AccountItemServiceFeeFormula: [
          { Text: "百分比", Value: 1 },
          { Text: "固定金额", Value: 0 }
        ],
        AccountItemShowPayway: [
          { Text: "默认显示", Value: 1 },
          { Text: "不默认显示", Value: 0 }
        ],
        AccountItemBalanceMode: [
          { Text: "余额大于等于零", Value: 1 },
          { Text: "余额小于零", Value: 2 },
          { Text: "任意", Value: 0 }
        ]
      },
      allSelectData: [],
      visible: false,
      goodsOption: {},
      WarehouseGoodsId: "",
      WarehouseGoodsName: "",
      isDisabled: true
    };
  },
  created() {
    const _this = this;

    _this.apiOptions = {
      api: "AccountItem_List",
      params: {},
      addApi: "AccountItem_Add",
      getApi: "AccountItem_Get",
      editApi: "AccountItem_Edit",
      delApi: "AccountItem_Del"
    };

    _this.option = {
      headSearch: {
        colnum: 3, //表单列数
        content: [
          {
            label: "类别",
            name: "AccountTypeId",
            type: "select",
            api: "Common_GetSelect",
            param: { Types: "accouttype" },
            dataField: "Data.accouttype"
          },
          {
            label: "结单性质",
            name: "Type",
            type: "select",
            api: "Common_GetSelect",
            param: { Types: "AccountItemType" },
            dataField: "Data.AccountItemType"
          },
          {
            label: "代码名称",
            name: "Name"
          }
        ]
      },
      form: {
        title: "账务代码", //表单标题
        width: 900, //宽度
        content: [
          {
            label: "代码",
            name: "Code",
            option: {
              validateFirst: true,
              rules: [
                { required: true, message: "请输入代码!" },
                {
                  validator: (rule, value, callback) => {
                    if (value.length >= 16) {
                      callback(new Error("账务代码长度最大为16位!"));
                    } else {
                      callback();
                    }
                  }
                  // message: "账务代码长度最大为16位!"
                }
              ]
            }
          },
          {
            label: "类别",
            name: "AccountTypeId",
            type: "select",
            api: "Common_GetSelect",
            param: { Types: "accouttype" },
            dataField: "Data.accouttype",
            option: {
              rules: [{ required: true, message: "请输入类别!" }]
            }
          },
          {
            label: "账务名称",
            name: "Name",
            option: {
              rules: [{ required: true, message: "请输入账务名称!" }]
            }
          },
          // {
          //   label: "结单性质",
          //   name: "Type",
          //   type: "select",
          //   data: _this.constSelectArray.AccountItemType,
          //   valueField: "Value",
          //   option: {
          //     rules: [{ required: true, message: "请输入结单性质!" }]
          //   },
          //   onChange: _this.AccountItemTypeChange
          // },
          //修改点
          {
            label: "结单性质",
            name: "Type",
            type: "select",
            api: "AccountAttributes_Get",
            dataField: "Data",
            valueField: "Type",
            textField: "TypeName",
            option: {
              rules: [{ required: true, message: "请选择结单性质!" }]
            },
            onChange: _this.AccountItemTypeChange
          },
          {
            label: "单位",
            name: "Unit"
          },
          {
            label: "单价",
            name: "UnitPrice",
            type: "number",
            min: 0,
            props: {
              precision: 2
            }
          },
          {
            label: "备注",
            name: "Remark"
          },
          {
            label: "状态",
            name: "AccountItemStatus",
            type: "select",
            valueField: "Value",
            data: _this.constSelectArray.AccountItemStatus,
            option: {
              rules: [{ required: true, message: "请输入状态!" }]
            }
          },
          {
            label: "分账",
            name: "AccountSplit",
            type: "number",
            min: 0,
            props: {
              precision: 2
            }
          },
          {
            label: "账务来源",
            name: "AccountItemSource",
            type: "select",
            valueField: "Value",
            data: _this.constSelectArray.AccountItemSource
          },
          {
            label: "应收代码",
            name: "ReceivableCode"
          },
          {
            label: "服务费",
            name: "ServiceFee",
            type: "number",
            min: 0,
            props: {
              precision: 2
            }
          },
          {
            label: "服务费计算方式",
            name: "AccountItemServiceFeeFormula",
            type: "select",
            valueField: "Value",
            data: _this.constSelectArray.AccountItemServiceFeeFormula
          },
          {
            label: "结账时默认显示",
            name: "AccountItemShowPayway",
            type: "select",
            valueField: "Value",
            data: _this.constSelectArray.AccountItemShowPayway
          },
          {
            label: "结账时余额选择",
            name: "AccountItemBalanceMode",
            type: "select",
            valueField: "Value",
            data: _this.constSelectArray.AccountItemBalanceMode
          },
          {
            label: "排序号",
            name: "Sort",
            type: "number" //计数器
          },
          {
            label: "属性",
            name: "Attributes",
            type: "checkbox-group",
            valueField: "value",
            data: [],
            //data: _this.constSelectArray.AccountItemAttributes,
            colnum: 2
          },
          {
            label: "关联仓库物品",
            slot: "warehouse"
          }
        ],
        add: {
          submitApi: _this.apiOptions.addApi,
          onOpenAfter: () => {
            let values = { AccountItemStatus: 1 };
            this.WarehouseGoodsName = "";
            this.WarehouseGoodsId = "";
            return values;
          },
          onSubmitBefore: values => {
            var itemAttributes = values.Attributes;
            var countAttributes = 0;
            if (itemAttributes != "") {
              for (let i = 0; i < itemAttributes.length; i++) {
                countAttributes += itemAttributes[i];
              }
              values.Attributes = countAttributes;
            } else {
              values.Attributes = "";
            }
            if (values.Type == "D") {
              values.WarehouseGoodsId = this.WarehouseGoodsId;
            }
            return values;
          }
        },
        edit: {
          infoApi: _this.apiOptions.getApi,
          submitApi: _this.apiOptions.editApi,
          onOpenAfter: res => {
            let json = res.Data;
            if (json.Type == "C") {
              this.WarehouseGoodsName = "";
              this.WarehouseGoodsId = "";
              this.isDisabled = true;
            } else if (json.Type == "D") {
              this.isDisabled = false;
              this.WarehouseGoodsName = json.WarehouseGoodsName;
              this.WarehouseGoodsId = json.WarehouseGoodsId;
            }
            const selectRow = this.allSelectData.filter(
              p => p.Type === json.Type
            );

            var AccountItemLists = [];
            for (let i = 0; i < selectRow[0].AccountItemLists.length; i++) {
              let item = {
                label: selectRow[0].AccountItemLists[i].ItemName,
                value: selectRow[0].AccountItemLists[i].Item
              };
              AccountItemLists.push(item);
            }
            this.setCheckData(AccountItemLists);
            const selectData = AccountItemLists;

            let currentSelect = [];
            for (let i = 0; i < selectData.length; i++) {
              const item = selectData[i];
              if ((json.Attributes | item.value) == json.Attributes) {
                currentSelect.push(item.value);
              }
            }
            json.Attributes = currentSelect;
            return json;
          },
          onSubmitBefore: values => {
            var itemAttributes = values.Attributes;
            var countAttributes = 0;

            if (itemAttributes != "") {
              for (let i = 0; i < itemAttributes.length; i++) {
                countAttributes += itemAttributes[i];
              }
              values.Attributes = countAttributes;
            } else {
              values.Attributes = "";
            }
            if (values.Type == "D") {
              values.WarehouseGoodsId = this.WarehouseGoodsId;
            }
            return values;
          }
        },
        del: {
          submitApi: _this.apiOptions.delApi,
          onSubmitBefore: values => {
            return values;
          }
        }
      },
      grid: {
        api: _this.apiOptions.api, //数据表格api
        columns: [
          {
            title: "序号",
            width: "5%", //宽度
            align: "center", //对齐方式
            type: "indexcolumn" // 类型，indexcolumn = 序号
          },
          { title: "代码", width: "8%", dataIndex: "Code", align: "center" },
          {
            title: "类别",
            width: "8%",
            dataIndex: "AccountTypeName",
            align: "center"
          },
          {
            title: "账务名称",
            dataIndex: "Name",
            align: "center"
          },
          {
            title: "单位",
            width: "7%",
            dataIndex: "Unit",
            align: "center"
          },
          {
            title: "单价",
            width: "7%",
            dataIndex: "UnitPrice",
            align: "right"
          },
          {
            title: "结单性质",
            width: "8%",
            dataIndex: "TypeName",
            align: "center"
          },
          {
            title: "关联仓库物品",
            width: "15%",
            dataIndex: "WarehouseGoodsName",
            align: "center"
          },
          {
            title: "排序号",
            width: "7%",
            dataIndex: "Sort"
          },
          {
            title: "状态",
            width: "7%",
            dataIndex: "AccountItemStatusName",
            align: "center"
          },
          {
            title: "操作",
            dataIndex: "Id",
            width: "15%",
            key: "action",
            align: "center",
            scopedSlots: { customRender: "rowAction" } //插槽 ，rowAction 默认的 编辑、删除 操作按钮插槽，如需其它按钮需自行定义插槽
          }
        ]
      }
    };
    //this.init(this.data);
    //
    _this.$post("AccountAttributes_Get").then(checkBoxData => {
      _this.allSelectData = checkBoxData.Data;
    });
    this.goodsOption = {
      //搜索框内容
      headSearch: {
        colnum: 1,
        content: [
          {
            label: "物品名称",
            name: "Keyword"
          }
        ],
        onSubmitBefore: values => {
          return values;
        }
      },
      //表格内容
      grid: {
        api: "Warehouse_GoodsList", //数据表格api
        params: {
          IsForBinding: true,
          Status: 1
        },
        columns: [
          {
            title: "序号",
            width: "10%", //宽度
            align: "center", //对齐方式
            type: "indexcolumn" // 类型，indexcolumn = 序号
          },
          {
            title: "物品名称",
            dataIndex: "Name",
            align: "center"
          },
          {
            title: "物品代码",
            dataIndex: "Code",
            width: "20%",
            align: "center"
          },
          {
            title: "物品分类",
            dataIndex: "CategoryName",
            width: "25%",
            align: "center"
          },
          {
            title: "单位",
            width: "12%",
            dataIndex: "UnitName",
            align: "center"
          }
        ]
      }
    };
  },
  methods: {
    addGoods() {
      this.visible = true;
    },
    submitGoods() {
      const row = this.$refs.goodsTable.getSelected();
      if (!row) {
        this.$message.error("请选择物品！");
        return false;
      }
      this.WarehouseGoodsId = row.Id;
      this.WarehouseGoodsName = row.Name;
      this.visible = false;
    },
    onCancel() {
      this.visible = false;
    },
    deGoods() {
      this.WarehouseGoodsId = "";
      this.WarehouseGoodsName = "";
    },
    AccountItemTypeChange(e, data) {
      var inputAccountItemLists = data.AccountItemLists;

      var AccountItemLists = [];
      for (let i = 0; i < inputAccountItemLists.length; i++) {
        let item = {
          label: inputAccountItemLists[i].ItemName,
          value: inputAccountItemLists[i].Item
        };
        AccountItemLists.push(item);
      }
      this.setCheckData(AccountItemLists);
      this.isDisabled = e == "C";
      if (e == "C") {
        this.WarehouseGoodsId = "";
        this.WarehouseGoodsName = "";
      }
      return AccountItemLists;
    },
    setCheckData(data) {
      const form = this.$refs.dataTable.getForm();
      form.setFieldData("Attributes", data);
    },
    selectChange(e, Data) {
      var _this = this;
      const formData = _this.$refs.dataTable.getFormData(true);

      _this.extendData2 = Data.Text;

      _this.$refs.dataTable.setFormData({
        ...formData,
        AllowPersonCount: Data.Data.AllowPersonCount
      });
    }
  }
};
</script>

<style scoped>
.data-table {
  min-height: auto;
  height: auto;
}
</style>
